import { render, staticRenderFns } from "./renewal-add.vue?vue&type=template&id=20f19610&scoped=true"
import script from "./renewal-add.vue?vue&type=script&lang=js"
export * from "./renewal-add.vue?vue&type=script&lang=js"
import style0 from "./renewal-add.vue?vue&type=style&index=0&id=20f19610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f19610",
  null
  
)

export default component.exports